"use client";
import {
	StopCircle as Gold,
	type Icon,
	Monitor,
	Moon,
	Sun,
} from "@layer/icons";

type ThemeType = {
	value: string;
	icon: Icon;
};

export const THEMES: ThemeType[] = [
	{
		value: "light",
		icon: Sun,
	},
	{
		value: "dark",
		icon: Moon,
	},
	{
		value: "system",
		icon: Monitor,
	},
	{
		value: "gold",
		icon: Gold,
	},
] as const;

export const THEME_VALUES = THEMES.map((theme) => theme.value);
